import { EQuantityFormatKey, IQuantityFormat } from '../../StoreSettings.types';

export enum EAbbreviationDropdownType {
  SEPARATOR = 'separator',
  BOOLEAN = 'boolean'
}

export interface IAbbreviationOfferTab {
  key: EQuantityFormatKey;
  label: string;
}

export interface IAbbreviationToggleField {
  key: keyof IQuantityFormat;
  label: string;
}

export interface IAbbreviationDropdownField extends IAbbreviationToggleField {
  type: EAbbreviationDropdownType;
}

export interface IAbbreviationDropdownOption {
  value: string;
  label: string;
}

export type QuantityFieldPath = `${EQuantityFormatKey}.${keyof IQuantityFormat}`;

export type QuantityFieldValue = string | number | boolean;
